import { OUTCOME_LEADS } from '../../campaigns'
import { LEAD, PURCHASE } from './index'

export const PROMOTED_PIXEL = 'promoted_pixel'
export const CUSTOM_EVENT_TYPE = 'custom_event_type'

export const getPromotedObjectInitialValues = campaignObjective => ({
  [PROMOTED_PIXEL]: '',
  [CUSTOM_EVENT_TYPE]: campaignObjective === OUTCOME_LEADS ? LEAD : PURCHASE
})
